import React from 'react'
import './services.css';
import { BiCheck } from 'react-icons/bi';

const services = () => {
    return (
        <section id="services">
            <h5>What I Do</h5>
            <h2>Work</h2>

            <div className="container services__container">
                <article className="service">
                    <div className="service__head">
                        <h3>UI / UX Design </h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>User interface design</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>User Experience</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>SEO Fundamentals</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Requirement Gathering</p>
                        </li>
                    </ul>
                </article>
                <article className="service">
                    <div className="service__head">
                        <h3> Management </h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p> Team Management</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p> Project Management</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Project Demo</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Sprint Planning</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Project Planning</p>
                        </li>
                    </ul>
                </article>
                <article className="service">
                    <div className="service__head">
                        <h3>Web Development </h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Development using Angular</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Developed SPA Apps</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Developed FinTech Tools</p>
                        </li>
                    </ul>
                </article>
            </div>
        </section>
    )
}

export default services